import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Two apps, one build:
//   booking.definesalons.com (public /book, /rate, /invoice)  -> "Define Salon Online Booking"
//   billing.definesalons.com (internal ERP / POS)             -> "Dynamic Billing"
export const BILLING_APP_NAME = "Dynamic Billing";
export const BOOKING_APP_NAME = "Define Salon Online Booking";
const PUBLIC_PREFIXES = ["/book", "/rate", "/invoice"];

export const isBookingApp = (pathname = window.location.pathname, host = window.location.hostname) =>
  host.startsWith("booking.") || PUBLIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

export const Branding = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const booking = isBookingApp(pathname);
    document.title = booking ? BOOKING_APP_NAME : BILLING_APP_NAME;
    const manifest = document.querySelector("link[rel=manifest]");
    if (manifest) manifest.setAttribute("href", booking ? "/manifest.json" : "/manifest-billing.json");
    const appName = document.querySelector("meta[name=application-name]");
    if (appName) appName.setAttribute("content", booking ? "Define Salons" : BILLING_APP_NAME);
    const appleTitle = document.querySelector("meta[name=apple-mobile-web-app-title]");
    if (appleTitle) appleTitle.setAttribute("content", booking ? "Define Salons" : BILLING_APP_NAME);
  }, [pathname]);
  return null;
};
